import axios from '@/plugins/axios';
import store from '@/store';

export default {
  search: async function (email, page = 1, limit = 10) {
    try {
      let response = await axios({
        method: 'get',
        url: '/api/v2/messages/search?email=' + encodeURIComponent(email) + '&page=' + page + '&limit=' + limit,
        headers: {
          'textree-token': store.state.admin.session.token
        }
      });
      console.log('error');
      return response.data || { blogs: [], total: 0 };
    } catch {
      return [];
    }
  },
  
};
